export const selectStreamerList = state => {
  return state.videoChat.onlineList;
  // filter(el => {
  //   const last = new Date(el.lastActivity);
  //   const now = new Date();
  //   const diff = now - last; // TODO
  //   return true;
  // });
};
